/* eslint-disable no-unused-vars */
import { useState } from 'react'
import useSWR from "swr"

import { GlobalContext } from "../context/GlobalContext";
import { api } from '../api/api';
import { ModalOrders } from '../components/Modals/Orders';
import { useOffCanvas } from '../hooks/useOffCanvas';

let open = false
let modal = null
export const GlobalProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user')) || {}
    } catch (error) {
      return {}
    }
  })
  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user'))?.permissions || null
    } catch (error) {
      return null
    }
  })
  const { closeOffCanvas, isOffCanvasOpen, toggleOffCanvas } = useOffCanvas()

  function isAccess(key = '', value = '') {
    if (user.typeUser === 'admin') {
      return 'admin'
    }

    if (user.typeUser === 'garcom') {
      return 'garcom'
    }

    if (key || value) {
      return userPermissions ? userPermissions[key]?.includes(value) : false
    }

    return false
  }


  useSWR('/companies', async () => {
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/register' ||
      window.location.pathname === '/recover-password' ||
      window.location.pathname === '/reset-password'
    ) {
      return
    }
    const response = await api.get('/companies')

    const dataUser = localStorage.getItem('user')

    const aux = {
      ...JSON.parse(dataUser),
      plan: response.data.plan,
      update: new Date().toISOString()
    }

    localStorage.setItem('user', JSON.stringify(aux))

    setUser(aux)

    return
  }, { refreshInterval: 60000, refreshWhenHidden: true })


  function openModalOrder() {
    if (open) {
      closeOffCanvas()
    }

    if (open === false) {
      toggleOffCanvas()
    }
  }

  return (
    <GlobalContext.Provider value={{ user, setUser, isAccess, userPermissions, setUserPermissions, openModalOrder, closeOffCanvas, isOffCanvasOpen, toggleOffCanvas }}>
      {children}
    </GlobalContext.Provider>
  )
}
